import "jquery-zoom";

$(document).ready(() => {
  const zoomer = $(".zoom").find("img");
  if (zoomer.attr("width") >= 640 && zoomer.attr("height") >= 360)
    $(".zoom").zoom();
});
